export class persistentServices {
  getItem(key) {
    let result = localStorage.getItem(key);
    try {
      result = JSON.parse(result);
    } catch(error) {
      console.debug(`Cannot get ${key} and decode from local storage.`);
    }
    return result;
  }

  setItem(key, value) {
    value = JSON.stringify(value);
    localStorage.setItem(key, value);
  }

  removeItem(key) {
    localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/persistent.services.js